"use client";

import { useAppDispatch, useAppStore } from "@/redux/hooks";
import { setCategoryData, setDevice, setCategorySlug } from "@/components/CategoryPage/redux/slice";
import { updateUserOnboarded } from "@/redux/slice/auth/slice";

const useSyncCategoryData = ({ categoryInfo, ua, categorySlug, userOnBoarded }) => {
  const dispatch = useAppDispatch();
  const store: any = useAppStore();

  if (store?.getState()?.category?.categorySlug === categorySlug) {
    return;
  } else {
    dispatch(setCategoryData(categoryInfo));
    dispatch(setDevice(ua));
    dispatch(setCategorySlug(categorySlug));
    dispatch(updateUserOnboarded(userOnBoarded));
  }
};

export { useSyncCategoryData };
